<template>
  <!-- <div class="item">
    <div class="id" v-if="source!=null">{{ source.namauser }} - {{ source.email }}</div>
  </div> -->

    <div class="col-md-6 col-lg-4" v-if="source!=null">
        <div class="card widget-profile pat-widget-profile">
            <div class="card-body" >
                <div class="pro-widget-content">
                    <div class="profile-info-widget">                        
                        <div class="profile-det-info">
                            <h3>{{ source.namauser }}</h3>                            
                            <div class="receiver-details">
                                <h5 class="mb-0"><i class="fas fa-envelope"></i>{{ source.email }}</h5>
                                <h5 class="mb-0"><i class="fas fa-phone"></i> {{ source.no_hp }}</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="receiver-info">
                    <div class="table-action" style="text-align: center;">
                        <v-btn class="btn btn-sm bg-info-light" depressed small @click="getEdit(source)">
                        <!-- <a href="javascript:void(0);" class="btn btn-sm bg-info-light"> -->
                            <i class="fas fa-print"></i> Edit
                        <!-- </a> -->
                        </v-btn>
                        <v-btn color="btn btn-sm bg-warning-light" depressed small @click="getDelete(source)">
                        <!-- <a href="javascript:void(0);" class="btn btn-sm bg-warning-light"> -->
                            <i class="far fa-eye"></i> Delete
                        <!-- </a> -->
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'item',
  props: {
    source: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>

<style scoped>
.item {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid lightgrey;
  padding: 1em;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/User/Item.vue